import { render, staticRenderFns } from "./TranslatorContactInformationList.vue?vue&type=template&id=4022c7fb&"
import script from "./TranslatorContactInformationList.vue?vue&type=script&lang=js&"
export * from "./TranslatorContactInformationList.vue?vue&type=script&lang=js&"
import style0 from "./TranslatorContactInformationList.vue?vue&type=style&index=0&id=4022c7fb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports